import { defineComponent as _defineComponent } from 'vue'
import Avatar from '../../common/Avatar.vue';
import useUserInfo from './useUserInfoHooks';
import '../../../directives/vTap';
import { roomService } from '../../../services';

interface Props {
  userId: string;
  userName: string;
  avatarUrl?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfoH5',
  props: {
    userId: null,
    userName: null,
    avatarUrl: null
  },
  emits: ['log-out'],
  setup(__props: any) {

const userInfoConfig = roomService.getComponentConfig('UserInfo');

const { userInfoRef, showUserControl, t, handleUserControl } = useUserInfo();



return { __sfc: true,userInfoConfig, userInfoRef, showUserControl, t, handleUserControl, Avatar }
}

})